// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageSkeleton_wrapper__1NCf1","img":"ImageSkeleton_img__1SohD","skeleton":"ImageSkeleton_skeleton__3ZQ96"};